import React from 'react';
import PropTypes from 'prop-types';

const FaceGood = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="face--good" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,23.1111111 C18.1364972,23.1111111 23.1111111,18.1364972 23.1111111,12 C23.1111111,5.86350278 18.1364972,0.888888889 12,0.888888889 C5.86350278,0.888888889 0.888888889,5.86350278 0.888888889,12 C0.888888889,18.1364972 5.86350278,23.1111111 12,23.1111111 Z M3.56882556,12.9966825 C3.50929279,12.7585514 3.65407532,12.5172472 3.89220639,12.4577144 C4.13033746,12.3981817 4.37164168,12.5429642 4.43117444,12.7810953 C5.56946801,17.3342695 8.06841478,19.5555556 12,19.5555556 C15.9315852,19.5555556 18.430532,17.3342695 19.5688256,12.7810953 C19.6283583,12.5429642 19.8696625,12.3981817 20.1077936,12.4577144 C20.3459247,12.5172472 20.4907072,12.7585514 20.4311744,12.9966825 C19.1990976,17.9249897 16.3647111,20.4444444 12,20.4444444 C7.63528893,20.4444444 4.80090236,17.9249897 3.56882556,12.9966825 Z" id="Combined-Shape" fill={color} fillRule="nonzero"></path>
      </g>
    </svg>
  );
}

FaceGood.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

FaceGood.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default FaceGood;



// WEBPACK FOOTER //
// ./src/components/Icons/FaceGood.jsx